export default "__VITE_ASSET__DAjJ8SXp__"